import ApiClient from '@/helpers/api/api.helpers';

class Dashboard extends ApiClient {
  constructor() {
    super('reports/dashboard');
  }
}

export default new Dashboard();
